import { render } from "./IconSvg.vue?vue&type=template&id=1eada142&scoped=true"
import script from "./IconSvg.vue?vue&type=script&lang=js"
export * from "./IconSvg.vue?vue&type=script&lang=js"

import "./IconSvg.vue?vue&type=style&index=0&id=1eada142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eada142"]])

export default __exports__